export const playback = {
  input: {
    media: {
      label: 'Audio files'
    },

    select_file: 'Select a file | Select files'
  },

  state: {
    init: {
      description:
        'Playback is a circuit element that allows the client to play back an audio recording. You can listen and download audio recordings.'
    }
  }
};
